module.exports = __webpack_public_path__ + "static/img/91BM-052-HankDu.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/91BM-052-HankDu.jpg
// module id = epp1
// module chunks = 0